













































import { defineComponent } from '@nuxtjs/composition-api';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  name: 'RelatedAccessory',
  props: {
    category: {
      type: String,
      required: true,
      default: null
    },
    brand: {
      type: String,
      required: true,
      default: null
    },
    spli_id: {
      type: Number,
      required: true,
      default: 0
    },
    media: {
      type: String,
      required: true,
      default: ''
    },
    media_file_name: {
      type: String,
      required: true,
      default: ''
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    ratingScore: {
      type: Number,
      default: 0
    },
    ratingsCount: {
      type: Number,
      default: 0
    },
    rating_number: {
      type: Number,
      required: false,
      default: 0
    },
    price: {
      type: Number,
      required: true,
      default: 0
    },
    sku: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    total_reviews: {
      type: Number,
      default: 0
    },
    can_be_ordered: {
      type: Boolean,
      default: true
    }
  },

  setup(props) {
    const formatUrl = useUrlFormatter();

    return {
      image: props.media,
      formatUrl
    };
  }
});
